import { render, staticRenderFns } from "./NoticeDetail.vue?vue&type=template&id=18edb694&scoped=true"
import script from "./NoticeDetail.vue?vue&type=script&lang=js"
export * from "./NoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetail.vue?vue&type=style&index=0&id=18edb694&prod&lang=css"
import style1 from "./NoticeDetail.vue?vue&type=style&index=1&id=18edb694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18edb694",
  null
  
)

export default component.exports